export default __webpack_public_path__ + "static/media/close.7a1dd278.webp";